export default __webpack_public_path__ + "static/SR USA - Ingrediente y Etiqueta - Declaración-ed371707a2ad65b99fdec2063f05c636.pdf";